import Layout from "~/components/layout";
import LoginImage from "~/images/Login.png";
import { Text } from "~/locales/text";

export default function Index() {
  return (
    <Layout>
      <div className="main-content">
        <div className="left-content">
          <img src={LoginImage} alt="" className="company-image" />
        </div>
        <div className="right-content flow">
          <h1 className="title-sm">
            <Text id="home-title" />
          </h1>
          <p className="text">
            <Text id="home-intro" />
          </p>
          <p className="text">
            <Text id="home-guidance" />
          </p>
        </div>
      </div>
    </Layout>
  );
}
